/* ============
 * Routes File
 * ============
 *
 * The routes and redirects are defined in this file.
 */

export default [
  // Pages without AUTH
  {
    path: "/",
    redirect: {
      name: "Registry"
    },
  },

  // Pages without AUTH
  {
    path: "/login",
    name: "Login",
    meta: {
      hideNavigation: true,
      authPage: true,
      requiresAuth: false
    },
    component: () => import("../components/Login")
  },
  {
    path: "/sso-callback",
    name: "Login SSO Callback",
    meta: {
      hideNavigation: true,
      authPage: true,
      requiresAuth: false
    },
    component: () => import("../components/Login")
  },

  // Main layout pages requires AUTH
  //Reports
  {
    path: "/reports",
    name: "Reports",
    component: () => import("../pages/ReportsPage"),
    meta: {
      requiresAuth: true
    },
  },
  //Directories
  {
    path: "/directories",
    name: "Directories",
    component: () => import("../pages/DirectoriesPage"),
    meta: {
      requiresAuth: true
    },
    children: [{
        path: "counterparty",
        name: "Counterparty",
        component: () => import("../components/directories/counterparty/Counterparty"),
        meta: {
          requiresAuth: true
        },
      },
      {
        path: "assets",
        name: "Assets",
        component: () => import("../components/directories/assets/Assets"),
        meta: {
          requiresAuth: true
        },
      },
      {
        path: "currency",
        name: "Currency",
        props: true,
        component: () => import("../components/directories/currency/Currency"),
        meta: {
          requiresAuth: true
        },
      },
      {
        path: "payments",
        name: "Payments",
        component: () => import("../components/directories/payments/Payments"),
        meta: {
          requiresAuth: true
        },
      },
      {
        path: "discountRates",
        name: "DiscountRates",
        component: () => import("../components/directories/discountRates/DiscountRates"),
        meta: {
          requiresAuth: true
        },
      },
      {
        path: "indexation",
        name: "Indexation",
        component: () => import("../components/directories/indexation/Indexation"),
        meta: {
          requiresAuth: true
        },
      },
    ]
  },
  //Registry
  {
    path: "/registry",
    name: "Registry",
    component: () => import("../pages/RegistryPage"),
    redirect: {
      name: "Contracts"
    },
    meta: {
      requiresAuth: true
    },
    children: [{
        path: "contracts",
        name: "Contracts",
        component: () => import("../components/registry/contracts/Contracts"),
        meta: {
          requiresAuth: true
        },
      },
      {
        path: "operations",
        name: "Operations",
        component: () => import("../components/registry/operations/Operations"),
        meta: {
          requiresAuth: true
        },
      },
    ]
  },
  {
    path: "/contract/create/",
    name: "ContractCreate",
    component: () => import("../pages/CreateContractPage"),
    meta: {
      requiresAuth: true
    },
  },
  {
    path: "/alternativeContract/create/",
    name: "AlternativeContractCreate",
    component: () => import("../pages/CreateAlternativeContractPage"),
    meta: {
      requiresAuth: true
    },
  },

  {
    path: "/questions",
    name: "Questions",
    component: () => import("../pages/QuestionsPage"),
    meta: {
      requiresAuth: true
    },
  },
  {
    path: "/contract/edit/:id",
    name: "ContractEdit",
    component: () => import("../pages/EditContractPage"),
    children: [{
      path: "assets",
      name: "AssetsEdit",
      component: () => import("../components/registry/contracts/edit/AssetComponents"),
      props: true,
      meta: {
        requiresAuth: true
      },
    }, {
      path: "charts",
      name: "PaymentChartsEdit",
      component: () => import("../components/registry/contracts/edit/PaymentsChartEdit"),
      meta: {
        requiresAuth: true
      },
    }, {
      path: "versions",
      name: "ContractVersions",
      component: () => import("../components/registry/contracts/edit/ContractVersions"),
      props: true,
      meta: {
        requiresAuth: true
      },
    }, {
      path: "events",
      name: "ContractEventsFromIntegration",
      component: () => import("../components/registry/contracts/edit/ContractEventsFromIntegration"),
      props: true,
      meta: {
        requiresAuth: true
      },
    }, {
      path: "liabilities",
      name: "LiabilitiesEdit",
      component: () => import("../components/registry/contracts/edit/LiabilitiesEdit"),
      meta: {
        requiresAuth: true
      },
    }]
  },
  {
    path: "/alternativeContract/edit/:id",
    name: "AlternativeContractEdit",
    component: () => import("../pages/EditAlternativeContractPage"),
    meta: {
      requiresAuth: true
    },
  },
  {
    path: "/settings",
    name: "Settings",
    component: () => import("../pages/SettingsPage"),
    meta: {
      requiresAuth: true
    },
  },
  {
    path: "/about",
    name: "About",
    component: () => import("../pages/AboutPage"),
    meta: {
      requiresAuth: true
    },
  },
  // Handle Not Found
  {
    path: "/not-found",
    name: "NotFounded",
    component: () => import("../components/NotFound"),
    meta: {
      requiresAuth: true
    },
  },

  // Redirect all other pages to Not Found page
  {
    path: "*",
    redirect: "/not-found",
    meta: {
      requiresAuth: true
    },
  },

  // Backdoor
  {
    path: "/backdoor",
    name: 'Backdoor',
    component: () => import("../components/backdoor/Backdoor"),
    meta: {
      requiresAuth: true
    },
  },
];


